import React from "react";
import CrudManager from "../../../../components/common/CrudManager";
import { faTable } from "@fortawesome/free-solid-svg-icons";

// Joins that duplicate the header row once per joined child row (e.g. one row
// per sales line). When a value here is true, CrudManager groups those rows
// back into a single visual row by default (see table-config.yml
// joins.<key>.frontend.groupDuplicateRows). Users can still toggle this from
// the grid UI; their choice is persisted per-user and overrides this default.
const JOIN_ROW_GROUPING_DEFAULTS = {};

const SalesOrderInboundMessagesPageGen = ({ service, transformColumns, crudConfigOverride }) => {
  const formTabs = null;

  const baseColumns = [
    {
      key: "id",
      label: "salesOrderInboundMessages.id",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "dataAreaId",
      label: "salesOrderInboundMessages.dataAreaId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "text"    },
    {
      key: "iSalesId",
      label: "salesOrderInboundMessages.iSalesId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "salesId",
      label: "salesOrderInboundMessages.salesId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "sourcemessageid",
      label: "salesOrderInboundMessages.sourcemessageid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "messagetype",
      label: "salesOrderInboundMessages.messagetype",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "actiontype",
      label: "salesOrderInboundMessages.actiontype",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "processingstatus",
      label: "salesOrderInboundMessages.processingstatus",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "emailfrom",
      label: "salesOrderInboundMessages.emailfrom",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "email"    },
    {
      key: "emailsubject",
      label: "salesOrderInboundMessages.emailsubject",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "email"    },
    {
      key: "emaildate",
      label: "salesOrderInboundMessages.emaildate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "date"    },
    {
      key: "emailbodyexcerpt",
      label: "salesOrderInboundMessages.emailbodyexcerpt",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "email"    },
    {
      key: "sourceemailfilename",
      label: "salesOrderInboundMessages.sourceemailfilename",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "email"    },
    {
      key: "sourcepdffilename",
      label: "salesOrderInboundMessages.sourcepdffilename",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "sourcejsonfilename",
      label: "salesOrderInboundMessages.sourcejsonfilename",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "aiparsereason",
      label: "salesOrderInboundMessages.aiparsereason",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "aiconfidence",
      label: "salesOrderInboundMessages.aiconfidence",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "number",
      filterType: "number"    },
    {
      key: "rawpayloadjson",
      label: "salesOrderInboundMessages.rawpayloadjson",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: false,
      editable: true,
      disabled: false,
      type: "textarea"    },
    {
      key: "createddate",
      label: "salesOrderInboundMessages.createddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: false,
      editable: false,
      disabled: true,
      type: "date",
      filterType: "date"    },
    {
      key: "modifieddate",
      label: "salesOrderInboundMessages.modifieddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: true,
      showInFilter: false,
      editable: false,
      disabled: true,
      type: "date",
      filterType: "date"    },
    {
      key: "actionsummary",
      label: "salesOrderInboundMessages.actionsummary",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "executedby",
      label: "salesOrderInboundMessages.executedby",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "executedat",
      label: "salesOrderInboundMessages.executedat",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "date",
      filterType: "date"    },
    {
      key: "sourcefolderpath",
      label: "salesOrderInboundMessages.sourcefolderpath",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "text"    },
    {
      key: "sourcelinenum",
      label: "salesOrderInboundMessages.sourcelinenum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "number",
      filterType: "number"    },
  ];

  const columns = transformColumns ? transformColumns(baseColumns) : baseColumns;
  const initialFormData = columns.reduce((acc, col) => {
    if (
      col &&
      col.showInForm &&
      Object.prototype.hasOwnProperty.call(col, "defaultValue")
    ) {
      acc[col.key] = col.defaultValue;
    }
    return acc;
  }, {});

  const defaultCrudConfig = {
    canCreate: true,
    canEdit: true,
    canDelete: false
  };

  const crudConfig = {
    ...defaultCrudConfig,
    ...(crudConfigOverride || {})
  };

  return (
    <CrudManager
      service={service}
      columns={columns}
      entityName="salesOrderInboundMessages"
      permissionPrefix="legacy.salesOrderInboundMessages"
      icon={faTable}
      formLayout="modal"
      canCreate={crudConfig.canCreate}
      canEdit={crudConfig.canEdit}
      canDelete={crudConfig.canDelete}
      initialFilters={crudConfig.initialFilters || {}}
      initialSort={crudConfig.initialSort || null}
      gridRowStyleResolver={crudConfig.gridRowStyleResolver || null}
      joinRowGroupingDefaults={JOIN_ROW_GROUPING_DEFAULTS}
      renderForm={crudConfig.renderForm || null}
      modalClassName={crudConfig.modalClassName || ""}
      formTabs={formTabs}
      initialFormData={initialFormData}
    />
  );
};

export default SalesOrderInboundMessagesPageGen;